var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../../less/IdStyles";
import { selectIsHudVisible } from "../../../../selectors/selectIsHudVisible";
import { selectIsModalOpen } from "../../../../selectors/selectModalTabId";
import { selectNewOrCompletedQuestsOutsideOfPage, selectQuestInfo, selectSortedQuest, } from "../../../../selectors/selectQuestInfo";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { ButtonQuestPanelCompleted } from "../../../generic/common/ButtonQuestPanelCompleted";
import { ButtonQuestPanelRecommended } from "../../../generic/common/ButtonQuestPanelRecommended";
import { ButtonQuestPanelTimeChallenge } from "../../../generic/common/ButtonQuestPanelTimeChallenge";
import { ButtonSecondaryAccentMedium } from "../../../generic/common/ButtonSecondaryAccentMedium";
import { HudQuestPagerButtonDown } from "../../../generic/common/HudQuestPagerButtonDown";
import { HudQuestPagerButtonUp } from "../../../generic/common/HudQuestPagerButtonUp";
import { QuestBoxContainer } from "../../../generic/common/QuestBoxContainer";
import { List } from "../../../generic/list/List";
import { Pager } from "../../../generic/pager/Pager";
import { TextLoca } from "../../../generic/text/TextLoca";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionQuestSelect } from "./actionQuests";
import { QuestButton } from "./QuestButton";
var HudQuestsListDOM = /** @class */ (function (_super) {
    __extends(HudQuestsListDOM, _super);
    function HudQuestsListDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.QuestsPerPage = 3;
        _this.StepPerPage = 1;
        _this.renderPager = function (page, changePage) {
            var quests = _this.props.quests;
            var pagerUpButton = _this.getPagerButton(HudQuestPagerButtonUp, page, changePage, -1);
            var pagerDownButton = _this.getPagerButton(HudQuestPagerButtonDown, page, changePage, 1);
            return (React.createElement("div", { className: "flex flex--aligned flex--around flex--stacked w100 h100" },
                React.createElement("div", { className: IdStyles.QuestPanelDivider }),
                pagerUpButton,
                React.createElement(List, { items: quests.slice(page, _this.QuestsPerPage + page), renderItem: _this.renderPagerItem, className: "flex flex--stacked flex--guts quest-hud-list" }),
                pagerDownButton));
        };
        _this.getPagerButton = function (Component, page, changePage, step) {
            var nextPage = page + step;
            var shouldRender = true;
            if ((nextPage < 0 && step < 0) || (nextPage > _this.PageCount - 1 && step > 0)) {
                shouldRender = false;
            }
            var showTooltip = _this.props.isNewQuestOutsideOfPage({
                page: page,
                pageCount: _this.PageCount,
                perPage: _this.QuestsPerPage,
                step: step,
            });
            return (shouldRender && (React.createElement("div", { className: "quest-hud-pager-button" },
                showTooltip && (React.createElement("span", { className: "tooltip__text tooltip__text--left " + IdStyles.TextNormal, style: { left: 115, marginTop: -10 } },
                    React.createElement(TextLoca, { id: IdLoca.showMore }))),
                React.createElement(Component, { onClick: function () { return changePage(nextPage); } }))));
        };
        _this.renderPagerItem = function (type) {
            var recommendedQuestId = _this.props.recommendedQuestId;
            return (React.createElement("div", { id: "hud_quest_" + type.id, className: "quest-button", key: type.id + "_" + type.priority + "_" + type.name },
                React.createElement(QuestButton, { quest: type, iconStyle: IdStyles.IconMedium, showSelectedQuest: false, onClick: _this.onQuestClick, getButton: _this.getButtonState, questBadgeClassName: "quest-button-badge", recommendedQuestId: recommendedQuestId })));
        };
        _this.getButtonState = function (isQuestCompleted, isQuestRecommended, isQuestTimeChallenge) {
            if (isQuestCompleted) {
                return ButtonQuestPanelCompleted;
            }
            else if (isQuestTimeChallenge) {
                return ButtonQuestPanelTimeChallenge;
            }
            else if (isQuestRecommended) {
                return ButtonQuestPanelRecommended;
            }
            return ButtonSecondaryAccentMedium;
        };
        _this.onQuestClick = function (quest) {
            var _a = _this.props, onQuestSelect = _a.onQuestSelect, isQuestMenuOpen = _a.isQuestMenuOpen, onOpenQuestScreen = _a.onOpenQuestScreen;
            onQuestSelect(quest);
            if (!isQuestMenuOpen) {
                onOpenQuestScreen();
            }
        };
        return _this;
    }
    HudQuestsListDOM.prototype.render = function () {
        var _a = this.props, shouldRender = _a.shouldRender, quests = _a.quests, recommendedQuest = _a.recommendedQuest;
        if (!shouldRender) {
            return React.createElement(React.Fragment, null);
        }
        this.PageCount = quests.length - this.QuestsPerPage + this.StepPerPage;
        var recommendedQuestElement = recommendedQuest != undefined && this.renderPagerItem(recommendedQuest);
        var scrollableQuests = quests.length > 0 && (React.createElement(Pager, { pageCount: this.PageCount }, this.renderPager));
        return (React.createElement(QuestBoxContainer, null,
            React.createElement("div", { className: "flex flex--aligned flex--around flex--stacked w100 h100" },
                recommendedQuestElement,
                scrollableQuests)));
    };
    return HudQuestsListDOM;
}(React.PureComponent));
var mapState = function (state) {
    var isQuestMenuOpen = selectIsModalOpen(state, IdModal.Quests);
    var quests = selectSortedQuest(state);
    var _a = selectQuestInfo(state), recommendedQuest = _a.recommendedQuest, recommendedQuestId = _a.recommendedQuestId;
    return {
        isNewQuestOutsideOfPage: selectNewOrCompletedQuestsOutsideOfPage(state),
        isQuestMenuOpen: isQuestMenuOpen,
        quests: quests,
        recommendedQuest: recommendedQuest,
        recommendedQuestId: recommendedQuestId,
        shouldRender: selectIsHudVisible(state),
    };
};
var mapDispatch = function (dispatch) { return ({
    onOpenQuestScreen: function () { return dispatch(actionModalOpen(IdModal.Quests)); },
    onQuestSelect: function (quest) { return dispatch(actionQuestSelect(quest)); },
}); };
export var HudQuestsList = connect(mapState, mapDispatch)(HudQuestsListDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/HudQuestsList.tsx
// module id = 2277
// module chunks = 3